import { useAppDispatch, useAppSelector } from '@/common/reducers/hooks/store.hook';
import { setIsPoll, setPoll } from '@/common/reducers/ScheduledMessageEditorReducer';
import { initialPoll } from '@/extension/context/content/components/add-scheduled-message-button/schedule-message-types';
import WSButton from '@common-components/ws-button/ws-button';
import PollIcon from '@mui/icons-material/Poll';
import { Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common/config/constants';



export const ToggleEditorTypeToPollOrMessageButton: React.FC = () => {
  const { t } = useTranslation(namespace);
  const dispatch = useAppDispatch();
  const poll = useAppSelector((state: any) => state.ScheduledMessageEditorReducer.poll);
  const isPoll = useAppSelector((state: any) => state.ScheduledMessageEditorReducer.isPoll);
  const editorType = isPoll ? 'poll' : 'message';


  const handleChangeEditorType = (value: { isPoll: boolean }) => {
    dispatch(setIsPoll(value.isPoll));
    if (value.isPoll) {
      // Initialize poll with default options if it's empty or doesn't have options
      const pollToSet = (poll && poll.options && poll.options.length > 0) ? poll : initialPoll;
      dispatch(setPoll(pollToSet));
    }
  }
  return (
    <WSButton
      onClick={() => {
        if (editorType === 'message') {
          handleChangeEditorType({ isPoll: true });
        } else {
          handleChangeEditorType({ isPoll: false });
        }
      }}
      sx={{
        color: 'var(--color-primary)',
        textTransform: 'none',
        letterSpacing: 0,
        fontWeight: 600,
        boxShadow: 'none',
        fontSize: '14px',
        padding: '4px 12px',
        backgroundColor: editorType === 'poll' ? 'var(--color-surface-muted)' : 'transparent',
        borderRadius: '14px',
        '&:hover': {
          backgroundColor: editorType === 'poll' ? 'var(--color-surface-muted)' : 'transparent',
        }
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <PollIcon sx={{ fontSize: 18, color: 'var(--color-text)' }} />
        <span style={{ color: 'var(--color-text)' }}>{editorType === 'poll' ? t('messageScheduling.switchToMessage') : t('messageScheduling.setPoll')}</span>
      </Stack>
    </WSButton>
  );
}; 